(function () {
  function init() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper || wrapper.dataset.stickyInitialized === 'true') return;
    wrapper.dataset.stickyInitialized = 'true';

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;width:100%;pointer-events:none;';
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    var observer = new IntersectionObserver(
      function (entries) {
        wrapper.classList.toggle('is-stuck', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
